import React from 'react'

interface IInfinityObserverProps {
  callback: (entry: IntersectionObserverEntry) => any
}

class InfinityObserver extends React.PureComponent<
  Readonly<IInfinityObserverProps>
> {
  private ref = React.createRef<HTMLDivElement>()
  private observer: IntersectionObserver | null = null

  componentDidMount(): void {
    try {
      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0]?.isIntersecting) {
            this.props.callback(entries[0])
          }
        },
        {
          root: null,
          rootMargin: '0px 0px -90% 0px',
          threshold: 0,
        },
      )
      this.ref.current && this.observer.observe(this.ref?.current)
    } catch (e) {
      console.error('fatal observer observe', e)
    }
  }

  componentWillUnmount(): void {
    try {
      this.observer?.disconnect()
    } catch (e) {
      console.error('fatal observer disconnect', e)
    }
  }

  render(): any {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { callback, ...props } = this.props
    return <div ref={this.ref} {...props} />
  }
}

export default InfinityObserver
